var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"map"},[_c('LazyLoad',[_c('MapComponent',{attrs:{"center":_vm.$path('location.coordinates', _vm.value)}})],1),_c('div',{staticClass:"scroll-anchor",attrs:{"id":"map"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }